import { render, staticRenderFns } from "./tabTrainRecord.vue?vue&type=template&id=6542bae1&"
import script from "./tabTrainRecord.vue?vue&type=script&lang=ts&"
export * from "./tabTrainRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports